module.exports = __webpack_public_path__ + "media/img/archi-2-ver-2-7b48e53b.png";